import { TYPES } from '../../action-types/vat-partner-edit';
import { IVatPartnersEditAction, IVatPartnersEditState } from './model';

export const defaultState: IVatPartnersEditState = {
	vatPartnersData: {},
	vatPartners: [],
	vatPartnersOptions: [],
	vatPartnerEditReasonCodesData: {},
	vatPartnerEditReasonOptions: [],
	vatPartnerEditReasonSelectOptions: [],
	originalData: [],
	tableData: {
		columns: [],
		data: [],		
		vendorData: {}
	},
	addUpdateVatPartnersISSOData: [],
	addUpdateVatPartnersISSOErrors: [],
	addUpdateVatPartnersESSOData: [],
	addUpdateVatPartnersESSOErrors: [],
	addUpdateError: [],
};

const formatVatPartners = (payload: any) => {
	if (!payload.data.length) {
		return [];
	}
	return payload.data.map((item: any) => (`${item.vatPartnerCode} - ${item.vatPartnerDescription}`));
};

const mapVatPartnersToOptions = (payload: any) => {
	if (!payload.data.length) {
		return [];
	}
	return payload.data.map((obj: any) => {
		if (obj.vatPartnerCode && obj.vatPartnerDescription) {
			return {
				value: obj.vatPartnerCode,
				optionText: `${obj.vatPartnerCode} - ${obj.vatPartnerDescription}`,
				label: `${obj.vatPartnerCode} - ${obj.vatPartnerDescription}`,
			};
		}
		return;
	});
};

const formatVatPartnerEditReasonCodes = (payload: any) => {
	if (!payload.data.length) {
		return [];
	}
	return payload.data.map((item: any) => (item.reasonDescription));
};

const mapReasonCodesToOptions = (payload: any) => {
	if (!payload.data.length) {
		return [];
	}
	return payload.data.map((obj: any) => {
		if (obj.reasonCodeNumber && obj.reasonDescription) {
			return {
				value: obj.reasonCodeNumber,
				optionText: `${obj.reasonCodeNumber} - ${obj.reasonDescription}`,
				label: `${obj.reasonCodeNumber} - ${obj.reasonDescription}`,
			};
		}
		return;
	});
};


export const reducer = (state: IVatPartnersEditState = defaultState, action: IVatPartnersEditAction) => {
	switch (action.type) {
		case TYPES.UPDATE_VAT_PARTNER_ISSO.PENDING:
			return {
				...state,
				addUpdateVatPartnersISSOData: [],
				addUpdateError: [],
			};
		case TYPES.UPDATE_VAT_PARTNER_ISSO.FULFILLED:
			return {
				...state,
				addUpdateVatPartnersISSOData: action.payload,
				addUpdateError: [],
			};
		case TYPES.UPDATE_VAT_PARTNER_ISSO.REJECTED:
			return {
				...state,
				addUpdateVatPartnersISSOData: [],
				addUpdateError: action.payload,
			};
		case TYPES.UPDATE_VAT_PARTNER_ISSO.RESET_ERROR:
			return {
				...state,
				addUpdateVatPartnersISSOData: [],
				addUpdateError: [],
			};
		case TYPES.UPDATE_VAT_PARTNER_ESSO.PENDING:
			return {
				...state,
				addUpdateVatPartnersESSOData: [],
				addUpdateError: [],
			};
		case TYPES.UPDATE_VAT_PARTNER_ESSO.FULFILLED:
			return {
				...state,
				addUpdateVatPartnersESSOData: action.payload,
				addUpdateError: [],
			};
		case TYPES.UPDATE_VAT_PARTNER_ESSO.REJECTED:
			return {
				...state,
				addUpdateVatPartnersESSOData: [],
				addUpdateError: action.payload,
			};
		case TYPES.UPDATE_VAT_PARTNER_ESSO.RESET_ERROR:
			return {
				...state,
				addUpdateVatPartnersESSOData: {},
				addUpdateError: {},
			};
		case TYPES.FETCH_VAT_PARTNERS.FULFILLED:
			return {
				...state,
				vatPartnersData: action.payload,
				vatPartners: formatVatPartners(action.payload),
				vatPartnersOptions: [
					{
						value: '',
						optionText: 'Select value...',
						label: 'Select value...',
					},
					...mapVatPartnersToOptions(action.payload)
				]
			};
		case TYPES.FETCH_VAT_PARTNERS.REJECTED:
			return {
				...state,
				vatPartnersData: {},
				vatPartners: [],
				vatPartnersOptions: []
			};
		case TYPES.FETCH_VAT_PARTNER_EDIT_REASONS.FULFILLED:
			return {
				...state,
				vatPartnerEditReasonCodesData: action.payload,
				vatPartnerEditReasonOptions: formatVatPartnerEditReasonCodes(action.payload),
				vatPartnerEditReasonSelectOptions: mapReasonCodesToOptions(action.payload)
			};
		case TYPES.FETCH_VAT_PARTNER_EDIT_REASONS.REJECTED:
			return {
				...state,
				vatPartnerEditReasonCodesData: {},
				vatPartnerEditReasonOptions: [],
				vatPartnerEditReasonSelectOptions: []
			};
		case TYPES.SET_VAT_PARTNERS_TABLE_DATA:
			return {
				...state,
				tableData: action.payload,
				originalData: action.payload.data.map((row: any) => (row.vatPartner ?  row.vatPartner : row.vatPartner = ''))
			};
		case TYPES.SET_VAT_PARTNERS_TABLE_ROWS:
			return {
				...state,
				tableData: {
					...state.tableData,
					data: action.payload
				}
			};
		case TYPES.SET_VAT_PARTNERS_TABLE_ROW:
			const { rowIndex, key, value } = action.payload;
			return {
				...state,
				tableData: {
					...state.tableData,
					data: state.tableData.data.map((row, index) =>
						index === rowIndex ? { ...row, [key]: value } : row
					)
				}
			};
		case TYPES.CLEAR_VAT_PARTNERS_TABLE_DATA:
			return {
				...state,
				tableData: [],
			};
		default:
			return state;
	}
};